import React, { useCallback } from 'react';
import { ServicesContext } from '../ServicesContext';

export interface ICDCode {
    id: number;
    report_year: number;
    code: string;
    description: string;
}

export const useGetICDCodes = () => {
    const services = React.useContext(ServicesContext);

    const getICDCodes = useCallback(
        async (search: string): Promise<ICDCode[]> => {
            const result: ApiDataResponseType<{ 'hydra:member': ICDCode[] }> =
                await services.api.call({
                    method: 'get',
                    url: '/api/icd-codes',
                    params: { code: search },
                });
            return result.data['hydra:member'];
        },
        [services.api]
    );

    return getICDCodes;
};
